import { render, staticRenderFns } from "./ColumnTask.vue?vue&type=template&id=650cc091&scoped=true&"
import script from "./ColumnTask.vue?vue&type=script&lang=js&"
export * from "./ColumnTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cc091",
  null
  
)

export default component.exports